module.exports = __webpack_public_path__ + "img/unauthenticated.76f170aa.png";